export default "__VITE_ASSET__CW6aqkxn__"